var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('button',{staticStyle:{"border":"none","background":"none","margin-right":"5px"},on:{"click":function($event){return _vm.detayaGit()}}},[_c('Icon',{attrs:{"icon":"akar-icons:search","color":"#7367f0","width":"15","height":"15"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }